import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { EconomyPaths } from '../economy.paths';
import { ECONOMY_TAB_ACTIVE_CLASS, ECONOMY_TAB_BASE_CLASS, ECONOMY_TAB_IDLE_CLASS } from '../economy-theme';

const TABS = [
  { key: 'summary', to: EconomyPaths.Summary },
  { key: 'budgetStatus', to: EconomyPaths.BudgetStatus },
  { key: 'operations', to: EconomyPaths.Operations },
  { key: 'settlement', to: EconomyPaths.Settlement },
  { key: 'companyCosts', to: EconomyPaths.CompanyCosts },
  { key: 'settings', to: EconomyPaths.Settings },
] as const;

export function EconomyTabs() {
  const { t } = useTranslation('economy');

  return (
    <nav className="flex flex-wrap items-end gap-x-8 border-b border-solid border-border">
      {TABS.map((tab) => (
        <NavLink
          key={tab.key}
          to={tab.to}
          replace
          className={({ isActive }) =>
            classNames(ECONOMY_TAB_BASE_CLASS, isActive ? ECONOMY_TAB_ACTIVE_CLASS : ECONOMY_TAB_IDLE_CLASS)
          }
        >
          {t(`tabs.${tab.key}`)}
        </NavLink>
      ))}
    </nav>
  );
}

export default EconomyTabs;
